const isNonRunner = (code?: string): boolean => Boolean(code === 'NP');

export { isNonRunner };
